import { RouteConfig } from 'vue-router';
/* eslint-disable */
// @ts-ignore
import * as children from './pages/*/routes.ts';
console.log('children', children);
/* eslint-enable */

export default {
  path: 'billing',
  name: 'billing',
  component: { template: '<router-view></router-view>' },
  children,
  redirect: {
    name: 'billings',
  },
} as RouteConfig;
